import * as $ from "jquery";
import portalConfirm from './portal-confirm';

export default (
    function()
    {
        $('a[data-confirm]').on('click', function(e) {
            var message = $(this).data('confirm');
            return (portalConfirm(message) === true);
        });
    }($, portalConfirm)
);